var map = {
	"./App.vue": "./js/App.vue",
	"./Components/CartWidget.vue": "./js/Components/CartWidget.vue",
	"./Components/Popup.vue": "./js/Components/Popup.vue",
	"./Components/SearchWidget.vue": "./js/Components/SearchWidget.vue",
	"./Components/UserWidget.vue": "./js/Components/UserWidget.vue",
	"./Demo/AddToCart.vue": "./js/Demo/AddToCart.vue",
	"./Demo/Cart.vue": "./js/Demo/Cart.vue",
	"./Demo/CartPage.vue": "./js/Demo/CartPage.vue",
	"./Util/Toast.vue": "./js/Util/Toast.vue",
	"./Util/Validator.vue": "./js/Util/Validator.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./js sync recursive .+\\.vue$";